import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import s from './Vouchers.module.scss';
import { ReactComponent as ChevronIcon } from 'images/new-icons/arrow-down-icon.svg';
import clsx from 'clsx';
import useGetSalonById from 'sdk/hooks/salon/useGetSalonById';
import useGetGiftCardsBySalonId from 'sdk/hooks/salon/useGetGiftCardsBySalonId';
import { useParams } from 'react-router-dom';
import { VoucherCard } from './VoucherCard';
import { format } from 'date-fns';

const variants = ['pink', 'teal', 'yellow', 'purple', 'blue', 'green', 'orange', 'red'];

const Vouchers = ({ onBuy }) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const { id } = useParams();
  const { data: salon } = useGetSalonById(id);
  const { data: giftCards } = useGetGiftCardsBySalonId(id);

  console.log('gift cards [', giftCards);
  const createVoucherData = (
    denomination: number,
    serviceName: string,
    validUntil: string,
    id?: number,
    external_id?: string,
    color?: string,
  ) => ({
    value: denomination,
    validUntil: format(new Date(validUntil), 'dd.MM.yyyy'),
    validFor: serviceName,
    salonName: salon?.name || '',
    serviceName: serviceName,
    avatarSrc: salon?.avatar,
    id: id,
    external_id: external_id,
    color: color,
  });

  if (!giftCards?.length) {
    return <div className={s.no_vouchers}>No gift cards found</div>;
  }

  return (
    <div className={s.vouchers}>
      <div className={s.vouchers_carousel_wrapper}>
        <Swiper
          spaceBetween={16}
          slidesPerView={'auto'}
          centeredSlides={true}
          className={s.vouchers_swiper}
        >
          {giftCards.map((card, index) => (
            <SwiperSlide key={card.id} className={s.vouchers_slide}>
              <div
                onClick={() =>
                  onBuy(
                    createVoucherData(
                      card.denomination,
                      card.services?.name,
                      card.valid_until,
                      card?.id,
                      card?.external_id,
                      card?.color,
                    ),
                  )
                }
                className={s.voucher_card_interactive}
              >
                <VoucherCard
                  variant={
                    variants.includes(card.color?.toLowerCase())
                      ? card.color?.toLowerCase()
                      : 'pink'
                  }
                  {...createVoucherData(
                    card.denomination,
                    card.services?.name,
                    card.valid_until,
                    card?.id,
                    card?.external_id,
                    card?.color,
                  )}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <div className={s.redemption_details}>
        <div className={s.redemption_header} onClick={() => setIsExpanded(!isExpanded)}>
          <div className={s.redemption_title}>Redemption Details</div>
          <ChevronIcon className={clsx(s.chevron, isExpanded && s.chevron_expanded)} />
        </div>
        {isExpanded && (
          <div className={s.redemption_content}>
            <ul className={s.redemption_list}>
              <li>This eGift Card can be redeemed on the Beautify app</li>
              <li>
                If the order total price is less than the voucher, we will keep the rest in the
                wallet, but if the order total price is higher than the wallet amount, then the
                customer has to pay the remaining amount by using one of the online payment methods
              </li>
              <li>
                How to redeem:
                <ul className={s.redemption_sub_list}>
                  <li>Open Beautify App & sign-in or register</li>
                  <li>Click on "More"</li>
                  <li>Click on "My Vouchers"</li>
                  <li>Click on "Add the voucher"</li>
                  <li>Your wallet will be recharged immediately</li>
                  <li>Now you can order & enjoy!</li>
                </ul>
              </li>
              <li>
                eGift Cards once issued cannot be canceled, exchanged, extended or refunded and are
                subject to the terms & conditions of the merchant.
              </li>
              <li>
                Items purchased using this eGift Card are refundable as per the refund and exchange
                policy of the merchant. The merchant is solely responsible for the product & service
                provided to customers through the use of this eGift Card.
              </li>
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default Vouchers;
